const notificationIcons = {
  success: 'fal fa-check-circle text-success',
  info: 'fal fa-info-circle text-info',
  warning: 'fal fa-exclamation-circle text-warning',
  error: 'fal fa-times-circle text-danger',
}

export default {
  namespaced: true,

  state: {
    notifications: [],
  },

  getters: {
    notifications(state) {
      return state.notifications
    },
  },

  mutations: {
    addNotification(state, notification) {
      if (typeof notification.id === 'undefined' || !notification.id) {
        throw new Error('Notification must have a unique ID.')
      }

      state.notifications.push(notification)
    },

    disableNotification(state, notificationId) {
      const index = state.notifications.findIndex(notification => notification.id === notificationId)

      if (index === -1) {
        return
      }

      state.notifications[index].disabled = true
    },

    removeNotification(state, notificationId) {
      const index = state.notifications.findIndex(notification => notification.id === notificationId)

      if (index === -1) {
        return
      }

      delete state.notifications[index]

      state.notifications = state.notifications.filter(notification => !!notification)
    },
  },

  actions: {
    addNotification({ commit, dispatch }, notification) {
      if (!notification.icon && notification.type) {
        notification.icon = notificationIcons[notification.type]
      }

      commit('addNotification', {
        ...notification,
        disabled: false,
      })

      if (typeof notification.timeout !== 'undefined') {
        setTimeout(() => dispatch('disableNotification', notification.id), notification.timeout)
      }
    },

    disableNotification({ commit }, notificationId) {
      console.log('Disabling notification', { notificationId })
      commit('disableNotification', notificationId)

      setTimeout(() => {
        console.log('Removing notification', { notificationId })
        commit('removeNotification', notificationId)
      }, 2000)
    },

    removeNotification({ commit }, notificationId) {
      commit('removeNotification', notificationId)
    },
  },
}
